import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "List-empty"
};
const _hoisted_2 = {
  key: 1,
  class: "List-finished"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_list = _resolveComponent("van-list");
  return _openBlock(), _createBlock(_component_van_list, {
    class: "ListContainer",
    ref: "listElement",
    finished: _ctx.isFinished,
    error: _ctx.isError,
    "onUpdate:error": _cache[0] || (_cache[0] = $event => _ctx.isError = $event),
    "error-text": "请求失败，点击重新加载",
    onLoad: _ctx.handleLoad,
    loading: _ctx.isLoading,
    "onUpdate:loading": _cache[1] || (_cache[1] = $event => _ctx.isLoading = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (v, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: "ListContainer-item"
      }, [_renderSlot(_ctx.$slots, "default", {
        index: index,
        v: v
      })]);
    }), 128)), _renderSlot(_ctx.$slots, "extra"), _ctx.isEmpty ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "empty", {}, () => [_createVNode(_component_van_empty, {
      image: "search",
      description: _ctx.emptyText
    }, null, 8, ["description"])])])) : _createCommentVNode("", true), _ctx.isFinished && !_ctx.isEmpty ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "finished", {}, () => [_cache[2] || (_cache[2] = _createElementVNode("p", {
      class: "van-list__finished-text"
    }, "已全部加载完毕", -1))])])) : _createCommentVNode("", true)]),
    _: 3
  }, 8, ["finished", "error", "onLoad", "loading"]);
}